module.exports = __webpack_public_path__ + "img/gamecellasia.8d24b4cf.png";